import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';

import Translatable from '../common/Translatable';
import { ButtonText } from '../buttons';

/**
 * FlatButton base component.
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const DialogCloseButton = props => {
    const StyledButton = styled(Button)`
        color: ${props => props.theme.palette.primary[800]};
        font-weight: normal;
    `;

    return (
        <StyledButton {...props} >
            <ButtonText buttonText={<Translatable message={'DIALOG_CLOSE_LABEL'} />} />
        </StyledButton>
    );
};

export default DialogCloseButton;



// WEBPACK FOOTER //
// ./src/components/buttons/DialogCloseButton.js